<template>
  <div>
    <div
      class="mob-bottom-nav"
      :class="{
        'header-hidden-mobile': resumeClinicOpen && !loginModalOpen,
        'header-over-modal': resumeClinicOpen && loginModalOpen,
      }"
    >
      <div
        class="nav-item"
        :class="{ active: notifOpen }"
        @click="toggleNotif"
      >
        <div class="nav-icon-container">
          <img
            v-if="notifOpen"
            src="@/assets/img/newMobNav/Bell_active.svg"
            alt="Notification"
          />
          <img
            v-else
            src="@/assets/img/newMobNav/Bell_inActive.svg"
            alt="Notification"
          />
          <img
            src="@/assets/img/newMobNav/Login_Dot_inActive.svg"
            class="notif-dot"
            alt=""
          />
        </div>
        <span>Notification</span>
      </div>

      <div class="nav-separator"></div>

      <div
        class="nav-item"
        :class="{ active: loginModalOpen }"
        @click="triggerLoginModal(loginModalOpen)"
      >
        <img
          v-if="loginModalOpen"
          src="@/assets/img/newMobNav/Login_active.svg"
          alt="Log In"
        />
        <img
          v-else
          src="@/assets/img/newMobNav/Login_Inactive.svg"
          alt="Log In"
        />
        <span>Log In</span>
      </div>
    </div>
  </div>
</template>

<script>
import { appConfig } from "@/config/appConfig";
import { eventBus } from "@/utils/eventBus";
export default {
  data() {
    return {
      loginModalOpen: false,
      isMobileMenuOpen: false,
      resumeClinicOpen: false,
      notifOpen: false,
    };
  },
  mounted() {
    this.onSetNotifOpen = (val) => {
      this.notifOpen = val;
    };
    eventBus.$on("set-notif-open", this.onSetNotifOpen);
    this.onCloseLoginModal = () => {
      this.loginModalOpen = false;
    };
    this.onOpenLoginModal = () => {
      this.loginModalOpen = true;
    };
    this.onMobileMenuState = (open) => {
      this.isMobileMenuOpen = !!open;
    };
    this.onResumeClinicState = (state) => {
      this.resumeClinicOpen = state;
    };
    this.onResumeClinicClosed = (state) => {
      this.resumeClinicOpen = state;
    };
    eventBus.$on("close-login-modal", this.onCloseLoginModal);
    eventBus.$on("open-login-modal", this.onOpenLoginModal);
    eventBus.$on("mobile-menu-state", this.onMobileMenuState);
    eventBus.$on("resume-clinic-state", this.onResumeClinicState);
    eventBus.$on("resume-clinic-closed", this.onResumeClinicClosed);

    // Sync state if modal is already open during mounting (e.g. on resize)
    const loginModal = document.getElementById("loginModal");
    if (loginModal && loginModal.classList.contains("show")) {
      this.loginModalOpen = true;
    }
  },

  beforeDestroy() {
    eventBus.$off("set-notif-open", this.onSetNotifOpen);
    eventBus.$off("close-login-modal", this.onCloseLoginModal);
    eventBus.$off("open-login-modal", this.onOpenLoginModal);
    eventBus.$off("mobile-menu-state", this.onMobileMenuState);
    eventBus.$off("resume-clinic-state", this.onResumeClinicState);
    eventBus.$off("resume-clinic-closed", this.onResumeClinicClosed);
  },

  watch: {},

  methods: {
    openLoginModal() {
      eventBus.$emit("open-login-modal");
    },

    toggleNotif() {
      const nextOpen = !this.notifOpen;
      if (nextOpen) {
        eventBus.$emit("close-resume-clinic");
      }
      if (nextOpen && this.loginModalOpen) {
        eventBus.$emit("close-login-modal");
      }
      if (nextOpen) {
        eventBus.$emit("close-header-search");
      }
      eventBus.$emit("set-notif-open", nextOpen);
    },
    triggerLoginModal(open) {
      if (open) {
        eventBus.$emit("close-login-modal");
        return;
      } else {
        eventBus.$emit("close-resume-clinic");
        eventBus.$emit("close-header-search");
        eventBus.$emit("close-mobile-menu");
        if (this.notifOpen) {
          eventBus.$emit("set-notif-open", false);
        }
        this.openLoginModal();
        this.loginModalOpen = true;
      }
    },
  },
};
</script>
<style scoped>
.mob-bottom-nav {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  bottom: -1px;
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  height: calc(80px + env(safe-area-inset-bottom));
  background: #ffffff;
  border-top: 1px solid #efefef;
  z-index: 1060;
}

.mob-bottom-nav .nav-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 4px;
}

.mob-bottom-nav .nav-item span {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: #7e808f;
}

.mob-bottom-nav .nav-item.active span {
  color: #20639b;
  font-weight: 700;
}

.mob-bottom-nav .nav-item img {
  height: 32px;
  width: auto;
}

.mob-bottom-nav .nav-icon-container {
  position: relative;
  display: flex;
}

.mob-bottom-nav .nav-icon-container .notif-dot {
  position: absolute;
  top: 1.35px;
  right: 0px;
  height: 6.78px !important;
  width: 6.78px !important;
  z-index: 2;
}

.mob-bottom-nav .nav-separator {
	width: 1px;
	height: 36px;
	background-color: #8C8C8C4D;
	align-self: center;
}

@media (min-width: 1028px) {
  .mob-bottom-nav {
    display: none;
  }
}
.header-hidden-mobile {
  display: none !important;
}
.header-over-modal {
  z-index: 2170 !important;
}
</style>
